export default __webpack_public_path__ + "static/media/headshot_cropped.7a71ea29.jpg";